<template>
  <el-container>
    <el-main>

      <el-row type="flex" justify="space-start" :gutter="20" style="margin-bottom:30px;">
           <el-col :span="6">
                    <el-card class="box-card">
            <div class="card-header" slot="header">
              <h4 class="card-title">New Daily Sales Figures</h4>
            </div>
          <ApolloMutation
  :mutation="require('./graphql/addSales.gql')"
  :variables="{
    date: newSales.date,
    eu: parseFloat(newSales.eu),
    uk: parseFloat(newSales.uk),
    us: parseFloat(newSales.us)
  }"
  @done="onDone"
>
  <template slot-scope="{ mutate, loading, error }">
       <el-form :model="newSales" :rules="rules" ref="newSales" label-width="120px">
                <el-row>
                    <el-form-item label="Date" prop="email">
                    <el-input
                      type="date"
                      label="Date"
                      placeholder="Date"
                      v-model="newSales.date"
                    ></el-input>
                  </el-form-item>
                </el-row>
                        <el-row>
                    <el-form-item label="UK" prop="uk">
                    <el-input
                      type="number"
                      step="0.01"
                      label="UK"
                      placeholder="UK"
                      v-model="newSales.uk"
                    ></el-input>
                  </el-form-item>
                </el-row>
                  <el-row>
                    <el-form-item label="Europe/ROW" prop="eu">
                    <el-input
                      type="number"
                      step="0.01"
                      label="Europe"
                      placeholder="Europe"
                      v-model="newSales.eu"
                    ></el-input>
                  </el-form-item>
                </el-row>
                          
                                   <el-row>
                    <el-form-item label="US" prop="us">
                    <el-input
                      type="number"
                      step="0.01"
                      label="US"
                      placeholder="US"
                      v-model="newSales.us"
                    ></el-input>
                  </el-form-item>
                </el-row>
    <button class="btn btn-primary" :disabled="loading" @click="mutate()">Save</button>
 <br /> <br />
    <el-alert title="Error" type="error" v-if="error">An error occurred: {{ error.message }}</el-alert>
    </el-form>
  </template>
</ApolloMutation>
                    </el-card>
           </el-col>
 <el-col :span="18">
          <el-card class="box-card">
            <div class="card-header" slot="header">
              <h4 class="card-title">List</h4>
            </div>
<ApolloQuery
        :query="require('./graphql/weeklySales.gql')"
        :variables="{
            fromDate: fromDate,
            toDate: toDate,
            sort: sort,
            dir: dir
        }"
>
        <template slot-scope="{ result: { data, loading } }">
             <div v-if="loading">Loading...</div>
               <data-tables-server  v-else-if="data"
                class="table-shopping"
                style="width: 100%"
                :data="data.sales"
                :tool-bar="false"
                :current-page="1"
                :total="data.sales.length"
                :loading="loading"
               
                :page-size="20"
                :pagination-props="{ pageSizes: [5, 10, 15, 20, 50] }"
              >
                  <el-table-column label="Date" min-width="100">
                  <template slot-scope="props">{{[props.row.date,'x'] | moment('DD/MM/YYYY')}}</template>
                </el-table-column>
                  <el-table-column label="EU" min-width="70">
                  <template slot-scope="props">{{props.row.eu}}</template>
                </el-table-column>
                   <el-table-column label="UK" min-width="70">
                  <template slot-scope="props">{{props.row.uk}}</template>
                </el-table-column>
                   <el-table-column label="US" min-width="70">
                  <template slot-scope="props">{{props.row.us}}</template>
                </el-table-column>
               </data-tables-server> 
             <div v-else class="no-result apollo">No result :(</div>
        </template>
</ApolloQuery>
          </el-card>
 </el-col>
      </el-row>
    </el-main>
  </el-container>
    
</template>
<script>
import gql from "graphql-tag";
import moment from "moment";
export default {
     data() {
         return {
             newSales:{},
            fromDate:moment().subtract(14,'days').format('YYYY-MM-DD'),
            toDate:moment().format('YYYY-MM-DD'),
            sort:"date",
            dir:"'ASC'",
            loading:false,
            error:false,
             rules: {
        date: [
          {
            required: true,
            message: "Please input date",
            trigger: "blur"
          }
        ]
        }
     }
     },
     methods:{
onDone(res){
this.$notify({
              title: "Success",
              message: res.data,
              type: "success"
            });
}
     }

}
</script>


// WEBPACK FOOTER //
// src/components/Finance/Sales.vue